import React from 'react';
import { NavLink, Link } from 'react-router-dom';


import { history } from '../../routers/AppRouter';

import SidebarMenusSub from './SidebarMenusSub';

import ROUTES from '../../data/routes';

class SidebarMenusSection extends React.PureComponent {
  onClick = async () => {
    const { menu } = this.props;
    await this.props.setActive(menu.label);
    if (menu.link) history.push(menu.link);
  }

  render() {
    const {
      icon, menu, subMenus, companyTag,
      countOfPendingRequests,
    } = this.props;

    return (
      <li className={`has-sub${this.props.isActive(menu.label) == true ? ' active' : ''}`}>
        <button type="button" className="main-menu sidebar-menu-btn" onClick={() => this.props.setActive(menu.label)}>
          <b className={`caret fa fa-${icon}`} />
          <i className={`fa fa-${icon}`} />
          <span>{menu.label}</span>
        </button>        
        <ul className="sub-menu">
          {subMenus.map(subMenu => (
            
              (subMenu.link &&
                <li
                className={subMenu.subMenus ? `has-sub` : ''}
                  key={subMenu.label}
                >
                <NavLink
                    exact
                    key={subMenu.id}
                    activeClassName="color-white"
                    onClick={(e) => {this.props.setSub(subMenu.label); history.push(menu.link)}}
                    to={ROUTES[subMenu.link] || ''}
                  >                    
                  {subMenu.label}
                  {(subMenu.link === 'REGISTER_SOLICITATION' && companyTag === 'chile')
                    && (<span className='notificationPendingSolicitationMenu'>{countOfPendingRequests}</span>)}
                  </NavLink>
                </li>
              ) ||
              (subMenu.subMenus && 
                <SidebarMenusSub
                key={subMenu.id}
                    icon={subMenu.icon || "list-ol"}
                    menu={{
                      label: subMenu.label,
                    }}
                    subMenus={subMenu.subMenus}
                    isActive={this.props.isActive}
                    setActive={this.props.setActive}
                />
              )            
          ))}
        </ul>
      </li>
    );
  }
}

export default SidebarMenusSection;
